import store from "../../store";

export default async function updateState(presenter){
  let response = await presenter.getData();
  store.dispatch({type: "app/updateState", path:presenter.storage_path, payload: response })
}

export function resetFrontState(){
  store.dispatch({type: "app/resetState"})
}